import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'

export class GetJudgeDetailUseCase {
  constructor(private judgeRepository: JudgeRepository) {}

  async getJudgeDetail(judgeId: string): Promise<JudgeDetail> {
    try {
      const data = await this.judgeRepository.getJudgeDetail(judgeId)
      return data
    } catch (error) {
      console.error(`Error in GetJudgeDetailUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
